import "./App.css";

import { fireStrore } from "./components/shared/firebaseReferences/firebaseReferences";
import { collection, getDocs } from "firebase/firestore";

import { Route, Routes, Redirect } from "react-router-dom";

import { useState, useEffect } from "react";

import { MobileNavigation } from "./components/pages/MobileNavigation/MobileNavigation";
import { NavBar } from "./components/navigation/NavBar/NavBar";
import { FrontPage } from "../src/components/pages/FrontPage/FronPage";
import { ShopPage } from "../src/components/pages/ShopPage/ShopPage";
import { ShopPageCatalogue } from "../src/components/pages/ShopPage/ShopPageCatalogue";
import { ShopPageFocusItem } from "../src/components/pages/ShopPage/ShopPageFocusItem";
import { ShopPageBigCart } from "../src/components/pages/ShopPage/ShopPageBigCart";
import { AboutUs } from "./components/pages/AboutUs/AboutUs";
import { Footer } from "./components/shared/Footer/Footer";
import { LoadingPage } from "./components/shared/LoadingPage/LoadingPage";
import { CheckoutPage } from "./components/pages/CheckoutPage/CheckoutPage";
import { GalleryPage } from "./components/pages/GalleryPage/GalleryPage";

import { SuccessPage } from "./components/pages/SuccessPage/SuccessPage";
import { async } from "@firebase/util";

let sizes = [
  { size: "EU-32 UK-13,5 US-1 20см", availableQuantity: 0 },
  { size: "EU-33 UK-1 US-1,5 20,5см", availableQuantity: 0 },
  { size: "EU-33,5 UK-1,5 US-2 21см", availableQuantity: 0 },
  { size: "EU-34 UK-2 US-2,5 21,5см", availableQuantity: 0 },
  { size: "EU-35 UK-2,5 US-3 22см", availableQuantity: 0 },
  { size: "EU-35,5 UK-3 US-3,5 2,5см", availableQuantity: 0 },
  { size: "EU-36 UK-3,5 US-4 23см", availableQuantity: 0 },
  { size: "EU-36,5 UK-4 US-4,5 23,5см", availableQuantity: 0 },
  { size: "EU-37,5 UK-4,5 US-5 23,5см", availableQuantity: 0 },
  { size: "EU-38 UK-5 US-5,5 24см", availableQuantity: 0 },
  { size: "EU-38,5 UK-5,5 US-6 24см", availableQuantity: 0 },
  { size: "EU-39 UK-6 US-6,5 24,5см", availableQuantity: 0 },

  { size: "EU-40 UK-6 US-7 25см", availableQuantity: 0 },
  { size: "EU-40,5 UK-6,5 US-7,5 25,5см", availableQuantity: 0 },
  { size: "EU-41 UK-7 US-8 26см", availableQuantity: 0 },
  { size: "EU-42 UK-7,5 US-8,5 26,5см", availableQuantity: 0 },
  { size: "EU-42,5 UK-8 US-9 27см", availableQuantity: 0 },
  { size: "EU-43 UK-8,5 US-9,5 27,5см", availableQuantity: 0 },
  { size: "EU-44 UK-9 US-10 28см", availableQuantity: 0 },
  { size: "EU-44,5 UK-9,5 US-10,5 28,5см", availableQuantity: 0 },
  { size: "EU-45 UK-10 US-11 29см", availableQuantity: 0 },
  { size: "EU-45,5 UK-10,5 US-11,5 29,5см", availableQuantity: 0 },
  { size: "EU-46 UK-11 US-12 30см", availableQuantity: 0 },
  { size: "EU-47 UK-11,5 US-12,5 30,5см", availableQuantity: 0 },
  { size: "EU-47,5 UK-12 US-13 31см", availableQuantity: 0 },
];

function App() {
  const [dataIsLoading, setDataIsLoading] = useState(true);
  const [mobileNavWidth, setmobileNavWidth] = useState(0);
  const [currentItemsCount, setCurrentItemsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsData, setItemsData] = useState([]);
  const [galleryData, setGalleryData] = useState([]);
  const [navbarVariation, setNavbarVariation] = useState("isProducts");
  const [navbarBackgroundColor, setNavbarBackgroundColor] = useState("none");
  const [navbarColors, setNavbarColors] = useState("white");
  const [navbarLogoColor, setNavbarLogoColor] = useState("white");
  const [navbarLogoWidth, setNavbarLogoWidth] = useState("10rem");
  const [navbarLogoFlexDirection, setNavbarLogoFlexDirection] =
    useState("column");
  const [navbarAlignItems, setNavbarAlignItems] = useState("start");
  const [navbarIconPMT, setNavbarIconPMT] = useState("0.5rem");

  const [cartContent, setCartContent] = useState([]);
  const [subtotalValue, setSubtotalValue] = useState(0);

  useEffect(() => {
    let allCatalogueData = [];
    let allGalleryData = [];

    const onloadFetch = async function () {
      await fetch(
        "https://us-central1-viko-admin-07.cloudfunctions.net/returnGalleryData"
      )
        .then((res) => res.json())
        .then((result) => {
          result.map((item) => {
            allGalleryData.push({
              imgId: item.imgId,
            });
          });
          setGalleryData(allGalleryData);
        });
      await fetch(
        "https://us-central1-viko-admin-07.cloudfunctions.net/returnFirestoreData"
      )
        .then((res) => res.json())
        .then((result) => {
          // variant fillter out not available sizes : start

          // result.map((item) => {
          //   let sizeIsAvailable = 0;
          //   item.sizes.map((sizee) => {
          //     if (sizee.availableQuantity > 0) {
          //       sizeIsAvailable = 1;
          //     }
          //   });
          //   if (sizeIsAvailable === 1) {
          //     allCatalogueData.push({
          //       id: item.id,
          //       name: item.name,
          //       description: item.description,
          //       imgId1: item.imgId1,
          //       imgId2: item.imgId2,
          //       imgId3: item.imgId3,
          //       imgId4: item.imgId4,
          //       isOnFrontPage: item.isOnFrontPage,
          //       isOnSale: item.isOnSale,
          //       oldPrice: item.oldPrice,
          //       price: item.price,
          //       category: item.category,
          //       description2: item.description2,
          //       sizes: item.sizes,
          //     });
          //   }
          // });
          // setItemsData(allCatalogueData);

          // variant fillter out not available sizes : end

          // varian show all items : start

          result.map((item) => {
            allCatalogueData.push({
              id: item.id,
              name: item.name,
              description: item.description,
              imgId1: item.imgId1,
              imgId2: item.imgId2,
              imgId3: item.imgId3,
              imgId4: item.imgId4,
              isOnFrontPage: item.isOnFrontPage,
              isOnSale: item.isOnSale,
              oldPrice: item.oldPrice,
              price: item.price,
              category: item.category,
              description2: item.description2,
              sizes: item.sizes,
            });
          });
          setItemsData(allCatalogueData);

          // varian show all items : end
        });
      setDataIsLoading(false);
    };

    onloadFetch();
  }, []);

  useEffect(() => {
    if (cartContent.length !== 0) {
      let newTotalPrice = 0;

      cartContent.map((item) => {
        newTotalPrice =
          (Math.round(Number(newTotalPrice) * 100) +
            Math.round(Number(item.price) * 100) * Number(item.count)) /
          100;
      });
      setSubtotalValue(newTotalPrice);
    } else {
      setSubtotalValue(0);
    }
  }, [cartContent]);

  const changeNavBar = (
    variation,
    colors,
    backgroundColor,
    logoWidth,
    logoFlexDirection
  ) => {
    setNavbarVariation(variation);
    setNavbarColors(colors);
    setNavbarBackgroundColor(backgroundColor);
    setNavbarLogoWidth(logoWidth);
    setNavbarLogoFlexDirection(logoFlexDirection);
  };

  const handleSetCurrentPage = (page) => {
    setCurrentPage(page);
  };

  const handleCartItemsCountChange = (count) => {
    setCurrentItemsCount((old) => old + Number(count));
  };

  function mobileNavShowFunction(width) {
    setmobileNavWidth(width);
  }

  function mobileNavHideFunction(width) {
    setmobileNavWidth(width);
  }

  function handleAddToCart(idData, countData, sizeData, nameData) {
    let existCheck = 0;
    itemsData.map((item) => {
      if (item.id === idData) {
        if (cartContent.length === 0) {
          setCartContent((old) => [
            ...old,
            {
              id: item.id,
              name: `${item.name}:${sizeData}`,
              price: item.price,
              imgSrc: item.imgId1,
              count: countData === 0 ? 1 : countData,
              size: sizeData,
            },
          ]);
          setSubtotalValue(
            (old) =>
              (Math.round(old * 100) +
                Math.round(item.price * 100) *
                  Number(countData === 0 ? 1 : countData)) /
              100
          );
          // setCartItemsCount((old) => old + 1);
          handleCartItemsCountChange("+1");
        } else {
          cartContent.map((oldItem) => {
            if (oldItem.name === `${item.name}:${sizeData}`) {
              existCheck = 1;
              let itemIndex = cartContent.indexOf(oldItem);
              cartContent[itemIndex] = {
                id: item.id,
                name: `${item.name}:${sizeData}`,
                price: item.price,
                imgSrc: item.imgId1,
                count:
                  Number(oldItem.count) +
                  Number(countData === 0 ? 1 : countData),
                size: sizeData,
              };
              // setRefreshTrigger((old) => old + 1);
              setSubtotalValue(
                (old) =>
                  (Math.round(old * 100) +
                    Math.round(item.price * 100) *
                      Number(countData === 0 ? 1 : countData)) /
                  100
              );
            }
          });
          if (existCheck === 0) {
            setCartContent((old) => [
              ...old,
              {
                id: item.id,
                name: `${item.name}:${sizeData}`,
                price: item.price,
                imgSrc: item.imgId1,
                count: countData === 0 ? 1 : countData,
                size: sizeData,
              },
            ]);
            setSubtotalValue(
              (old) =>
                (Math.round(old * 100) +
                  Math.round(item.price * 100) *
                    Number(countData === 0 ? 1 : countData)) /
                100
            );
            // setCartItemsCount((old) => old + 1);
            handleCartItemsCountChange("+1");
          }
        }
      }
    });
    // setCartContent(data);
  }

  function handleRemoveItem(nameData, sizeData) {
    cartContent.map((item) => {
      if (item.name === nameData) {
        setCartContent(
          cartContent.filter((filterItem) => filterItem.name !== item.name)
        );
      }
    });
  }

  function handleUpdateCart(nameData, countData) {
    let newTotalPrice = 0;
    cartContent.map((item) => {
      if (item.name === nameData) {
        item.count = countData;
      }
    });
    cartContent.map((item) => {
      newTotalPrice =
        (Math.round(Number(newTotalPrice) * 100) +
          Math.round(Number(item.price) * 100) * Number(item.count)) /
        100;
    });
    setSubtotalValue(newTotalPrice);
  }
  function handleEmptyCart() {
    setCartContent([]);
  }
  return (
    <>
      {dataIsLoading === true ? (
        <LoadingPage />
      ) : (
        <div className="app-container">
          <NavBar
            currentItemsCount={cartContent.length}
            variation={navbarVariation}
            mobileNavShowFunction={mobileNavShowFunction}
            bakgrounColor={navbarBackgroundColor}
            navButtonsColor={navbarColors}
            navbarLogoFlexDirection={navbarLogoFlexDirection}
            navbarLogoWidth={navbarLogoWidth}
            navbarLogoColor={navbarLogoColor}
            navbarAlignItems={navbarAlignItems}
            navbarIconPMT={navbarIconPMT}
          />
          <MobileNavigation
            mobileNavHideFunction={mobileNavHideFunction}
            divWidth={mobileNavWidth}
            currentItemsCount={cartContent.length}
          />

          <Routes>
            <Route
              exact
              path="/"
              element={
                <FrontPage
                  itemsData={itemsData}
                  mobileNavShowFunction={mobileNavShowFunction}
                  handleCartItemsCountChange={handleCartItemsCountChange}
                  changeNavBar={changeNavBar}
                />
              }
            />
            <Route
              exact
              path="/shop"
              element={
                <ShopPage
                  subtotalValue={subtotalValue}
                  handleAddToCart={handleAddToCart}
                  handleRemoveItem={handleRemoveItem}
                  itemsData={itemsData}
                  cartContent={cartContent}
                  mobileNavShowFunction={mobileNavShowFunction}
                  handleCartItemsCountChange={handleCartItemsCountChange}
                  changeNavBar={changeNavBar}
                  handleSetCurrentPage={handleSetCurrentPage}
                  currentPage={currentPage}
                />
              }
            >
              <Route path="" element={<ShopPageCatalogue />} />
              <Route path="item:id" element={<ShopPageFocusItem />} />
            </Route>
            <Route
              exact
              path="/cart"
              element={
                <ShopPageBigCart
                  handleUpdateCart={handleUpdateCart}
                  subtotalValue={subtotalValue}
                  cartContent={cartContent}
                  handleRemoveItem={handleRemoveItem}
                  changeNavBar={changeNavBar}
                />
              }
            ></Route>
            <Route
              exact
              path="/about-us"
              element={<AboutUs changeNavBar={changeNavBar} />}
            ></Route>
            <Route
              exact
              path="/checkout"
              element={
                <CheckoutPage
                  changeNavBar={changeNavBar}
                  cartContent={cartContent}
                  subtotalValue={subtotalValue}
                  handleEmptyCart={handleEmptyCart}
                />
              }
            ></Route>
            <Route
              exact
              path="/gallery"
              element={
                <GalleryPage
                  galleryData={galleryData}
                  changeNavBar={changeNavBar}
                />
              }
            ></Route>

            <Route
              exact
              path="/success"
              element={<SuccessPage changeNavBar={changeNavBar} />}
            ></Route>
          </Routes>
          <Footer />
        </div>
      )}
    </>
  );
}

export default App;
